"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var TimeBaseComponent =
/** @class */
function (_super) {
  __extends(TimeBaseComponent, _super);

  function TimeBaseComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      locale: undefined
    };
    return _this;
  }

  TimeBaseComponent.prototype.componentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      var locale;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , getLocale(this.props.locale)];

          case 1:
            locale = _a.sent();

            if (locale) {
              this.setState({
                locale: locale
              });
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return TimeBaseComponent;
}(React.Component);

exports.TimeBaseComponent = TimeBaseComponent;

function getLocale(preferredLocale) {
  return __awaiter(this, void 0, void 0, function () {
    var languages, locale, _a, _i, languages_1, l, _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          languages = navigator && navigator.languages || navigator.language && [navigator.language];
          if (!(preferredLocale && languages.includes(preferredLocale) && locales[preferredLocale])) return [3
          /*break*/
          , 4];
          _c.label = 1;

        case 1:
          _c.trys.push([1, 3,, 4]);

          return [4
          /*yield*/
          , locales[preferredLocale]()];

        case 2:
          return [2
          /*return*/
          , _c.sent()];

        case 3:
          _a = _c.sent();
          return [3
          /*break*/
          , 4];

        case 4:
          _i = 0, languages_1 = languages;
          _c.label = 5;

        case 5:
          if (!(_i < languages_1.length)) return [3
          /*break*/
          , 10];
          l = languages_1[_i];

          if (!locales[l]) {
            return [3
            /*break*/
            , 9];
          }

          _c.label = 6;

        case 6:
          _c.trys.push([6, 8,, 9]);

          return [4
          /*yield*/
          , locales[l]()];

        case 7:
          locale = _c.sent();
          return [3
          /*break*/
          , 10];

        case 8:
          _b = _c.sent();
          return [3
          /*break*/
          , 9];

        case 9:
          _i++;
          return [3
          /*break*/
          , 5];

        case 10:
          return [2
          /*return*/
          , locale];
      }
    });
  });
}

var locales = {
  en: function en() {
    return undefined;
  },
  af: function af() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/af');
    });
  },
  'ar-SA': function arSA() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/ar-SA');
    });
  },
  bn: function bn() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/bn');
    });
  },
  de: function de() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/de');
    });
  },
  el: function el() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/el');
    });
  },
  'en-CA': function enCA() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/en-CA');
    });
  },
  'en-GB': function enGB() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/en-GB');
    });
  },
  'en-US': function enUS() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/en-US');
    });
  },
  eo: function eo() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/eo');
    });
  },
  es: function es() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/es');
    });
  },
  et: function et() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/et');
    });
  },
  fr: function fr() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/fr');
    });
  },
  gl: function gl() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/gl');
    });
  },
  he: function he() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/he');
    });
  },
  hu: function hu() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/hu');
    });
  },
  it: function it() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/it');
    });
  },
  ja: function ja() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/ja');
    });
  },
  lt: function lt() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/lt');
    });
  },
  nb: function nb() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/nb');
    });
  },
  nl: function nl() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/nl');
    });
  },
  'pt-BR': function ptBR() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/pt-BR');
    });
  },
  ru: function ru() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/ru');
    });
  },
  sv: function sv() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/sv');
    });
  },
  uk: function uk() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/uk');
    });
  },
  vi: function vi() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/vi');
    });
  },
  'zh-CN': function zhCN() {
    return Promise.resolve().then(function () {
      return require('date-fns/locale/zh-CN');
    });
  }
};